
/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


import Turbolinks from 'turbolinks';
import Vue from 'vue/dist/vue.esm.js';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import CKEditor from 'ckeditor4-vue';

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['trix-editor', 'trix-toolbar'];
window.Vue = Vue;
Vue.use(VueResource);
Vue.use( CKEditor );
Vue.use(VeeValidate);

Turbolinks.start()

function destroyVue() {
  this.$destroy()
  document.removeEventListener('turbolinks:before-render', destroyVue)
}

document.addEventListener('turbolinks:load', () => {
  const element = document.getElementById('app')

  const app = new Vue({
    el: element,
    ignoredElements: ['trix-editor', 'trix-toolbar'],

    beforeMount: function() {
      this.$originalElement = this.$el.outerHTML
      document.addEventListener('turbolinks:before-render', destroyVue.bind(this))
    },

    mounted() {
      $(document).trigger('load');
    },

    destroyed: function() {
      this.$el.outerHTML = this.$originalElement
    },

    created: function () {
      Vue.http.interceptors.push((request, next)  => {
        request.headers.set('Authorization', 'Bearer ' + localStorage.getItem("token"))
        request.headers.set('Accept', 'application/json')
        next();
      })
    },
    methods: {
      refreshTrix : function(){
        let trix = this.$el.querySelector('trix-toolbar')
        trix.parentNode.removeChild(trix);
      }
    },
    components: {
      'hero-slider': () => import ('./components/hero-slider.vue'),
      'listing': () => import ('./components/listing.vue'),
      'listing-map': () => import ('./components/listing-map.vue'),
      'listing-approximate-map': () => import ('./components/listing-approximate-map.vue'),
      'listing-index': () => import ('./components/listing-index.vue'),
      'listing-search': () => import ('./components/listing-search.vue'),
      'listing-show-map': () => import ('./components/listing-show-map.vue'),
      'listing-slider': () => import ('./components/listing-slider.vue'),
      'secondary-reviews-slider': () => import ('./components/secondary-reviews-slider.vue'),
      'primary-reviews-slider': () => import ('./components/primary-reviews-slider.vue'),
      'listing-toggle-description': () => import ('./components/listing-toggle-description.vue'),
      'service-card': () => import ('./components/service-card.vue'),
      'home-search': () => import ('./components/home-search.vue'),
      'custom-select': () => import ('./components/custom-select.vue'),
      'admin-listing-address': () => import ('./components/admin-listing-address.vue'),
      'admin-neighborhood-new': () => import ('./components/admin-neighborhood-new.vue'),
      'dashboard-requests': () => import ('./components/dashboard-requests.vue'),
      'copy-text': () => import ('./components/copy-text.vue'),
      'tooltip': () => import ('./components/tooltip.vue'),
      'icon-tooltip': () => import ('./components/icon-tooltip.vue'),
      'newsletter': () => import ('./components/newsletter.vue'),
      'listings-for-export': () => import ('./components/listings-for-export.vue'),
      'email-export': () => import ('./components/email-export.vue'),
    }
  })
})



// WEBPACK FOOTER //
// app/javascript/application.js